var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19354_40629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19354_40629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.6663C7.07776 14.6663 6.21109 14.4913 5.39998 14.1413C4.58887 13.7913 3.88331 13.3163 3.28331 12.7163C2.68331 12.1163 2.20831 11.4108 1.85831 10.5997C1.50831 9.78856 1.33331 8.9219 1.33331 7.99967C1.33331 7.07745 1.50831 6.21079 1.85831 5.39967C2.20831 4.58856 2.68331 3.88301 3.28331 3.28301C3.88331 2.68301 4.58887 2.20801 5.39998 1.85801C6.21109 1.50801 7.07776 1.33301 7.99998 1.33301C8.9222 1.33301 9.78887 1.50801 10.6 1.85801C11.4111 2.20801 12.1166 2.68301 12.7166 3.28301C13.3166 3.88301 13.7916 4.58856 14.1416 5.39967C14.4916 6.21079 14.6666 7.07745 14.6666 7.99967C14.6666 8.9219 14.4916 9.78856 14.1416 10.5997C13.7916 11.4108 13.3166 12.1163 12.7166 12.7163C12.1166 13.3163 11.4111 13.7913 10.6 14.1413C9.78887 14.4913 8.9222 14.6663 7.99998 14.6663ZM7.99998 13.333C8.59998 13.333 9.17776 13.2358 9.73331 13.0413C10.2889 12.8469 10.8 12.5663 11.2666 12.1997L3.79998 4.73301C3.43331 5.19967 3.15276 5.71079 2.95831 6.26634C2.76387 6.8219 2.66665 7.39967 2.66665 7.99967C2.66665 9.48856 3.18331 10.7497 4.21665 11.783C5.24998 12.8163 6.51109 13.333 7.99998 13.333ZM12.2 11.2663C12.5666 10.7997 12.8472 10.2886 13.0416 9.73301C13.2361 9.17745 13.3333 8.59967 13.3333 7.99967C13.3333 6.51079 12.8166 5.24967 11.7833 4.21634C10.75 3.18301 9.48887 2.66634 7.99998 2.66634C7.39998 2.66634 6.8222 2.76356 6.26665 2.95801C5.71109 3.15245 5.19998 3.43301 4.73331 3.79967L12.2 11.2663Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not-equal.c2f3ca5d687f9aa82a56ebf8781697c2.svg";
export { ForwardRef as ReactComponent };